import { apiService } from './api.service';
import { ANALYTICS_API_ENDPOINTS } from '../constants/analytics.constants';
import {
  AnalyticsOverview,
  AnalyticsRangeParams,
  AnalyticsTimelineParams,
  TimelinePoint,
  UserContribution,
} from '../types/analytics.types';

const toQueryRecord = (params?: Record<string, string | undefined>): Record<string, string> | undefined => {
  if (!params) return undefined;
  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== '') out[key] = value;
  }
  return Object.keys(out).length > 0 ? out : undefined;
};

class AnalyticsService {
  async getOverview(params?: AnalyticsRangeParams): Promise<AnalyticsOverview> {
    return apiService.get<AnalyticsOverview>(
      ANALYTICS_API_ENDPOINTS.OVERVIEW,
      toQueryRecord(params as Record<string, string | undefined> | undefined),
    );
  }

  async getTimeline(params?: AnalyticsTimelineParams): Promise<TimelinePoint[]> {
    return apiService.get<TimelinePoint[]>(
      ANALYTICS_API_ENDPOINTS.TIMELINE,
      toQueryRecord(params as Record<string, string | undefined> | undefined),
    );
  }

  async getUserContributions(params?: AnalyticsRangeParams): Promise<UserContribution[]> {
    return apiService.get<UserContribution[]>(
      ANALYTICS_API_ENDPOINTS.USERS,
      toQueryRecord(params as Record<string, string | undefined> | undefined),
    );
  }
}

export const analyticsService = new AnalyticsService();
